import DataTable from 'react-data-table-component'
import Modal from 'react-bootstrap/Modal'
import {useEffect, useMemo, useState, useRef} from 'react'
import {
  fetchData,
  fetchFormData,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import 'react-datepicker/dist/react-datepicker.css'
import {ToastContainer} from 'react-toastify'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit} from '@fortawesome/free-solid-svg-icons'
import {Tr} from '../../../_metronic/i18n/Tr'

  const Popup = (props: any) => {
      let t = Tr()

    // add / edit facility states
    const [categoryId, setcategoryId] = useState(props.categoryId)
    const [enName, setEnName] = useState('')
    const [ruName, setRuName] = useState('')
    const [uzName, setUzName] = useState('')
    const [error, setError] = useState(Object)
    const [image, setImage] = useState()
    const [imageUrl, setImageUrl] = useState('')
    const [disable, setDisable] = useState(false)

    const savecategory = async () => {
      setDisable(true)

      let param = new FormData()
      param.append('enName', enName.trim())
      param.append('ruName', ruName != null ? ruName.trim() : '')
      param.append('uzName', uzName != null ? uzName.trim() : '')
 
      if (image != null && image != undefined) {
        param.append('image', image ? image : '')
      }
      if (props.categoryId != '' && props.categoryId != null && props.categoryId > 0) {
        param.append('categoryId', props.categoryId)
      }

      var res = await fetchFormData('admin/addeditcategory', param)

      if (res.status == '200') {
        if (props.categoryId !== '' && props.categoryId !== null && props.categoryId > 0) {
          toastsuccessmsg('Service Updated Successfully')
        } else {
          toastsuccessmsg('Service Added Successfully')
        }
        setDisable(false)
        props.onHide()
      } else {
        setDisable(false)
        toasterrormsg(res.message)
      }
    }
    const validate = () => {
      var errotmp: any = {}
      var err = 0
      if (enName.trim() == '' || enName.trim() == null || enName.trim() == undefined) {
        errotmp['enNameError'] = t('Category English Name Is Required')
        err = 1
      } else if (enName.trim().length > 50) {
        errotmp['enNameError'] = t('Category English Name Is Too Large')
        err = 1
      }

      if (ruName != null && ruName.trim().length > 50) {
        errotmp['ruNameError'] = t('Category russian Name Is Too Large')
        err = 1
      }
      if (uzName != null && uzName.trim().length > 50) {
        errotmp['uzNameError'] = t('Category Uzbek Name Is Too Large')
        err = 1
      }

      if (
        (image == null || image == undefined) &&
        (imageUrl == '' || imageUrl == null || imageUrl == undefined)
      ) {
        errotmp['imageError'] = t('Category Image Is Required')
        err = 1
      }
      setError(errotmp)
      if (err == 0) {
        savecategory()
      }
    }
    const categorydetail = async (catlist: any) => {
      var param = {
        categoryId: props.categoryId,
      }
      var res = await fetchData('admin/categorydetail', param)
      if (res.status == '200') {
        var data = res.data[0]

        setImageUrl(data.image)
        setEnName(data.en_name)
        setRuName(data.ru_name)
        setUzName(data.uz_name)

      } else {
        toasterrormsg(res.message)
      }
    }

    useEffect(() => {
      if (props.categoryId > 0) {
        categorydetail(props.categoryId)
      }
    }, [])

    // add / edit facility state end
    return (
      <Modal
        {...props}
        size='xl'
        aria-labelledby='contained-modal-title-hcenter'
        dialogClassName='maxwidth1000px'
        centered
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className='d-flex align-items-center col-10'>
            <h4 className='fw-bold'>
              {categoryId !== '' && categoryId !== null && categoryId > 0 ? t('Edit') : t('Add')}{' '}
              {t('Category')}
            </h4>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className='stepper stepper-links d-flex flex-column'
            id='kt_create_account_stepper'
            data-kt-stepper='true'
          >
            <div className='mx-auto mw-600px w-100 py-10' id='kt_create_account_form'>
              <div>
                {/* <!--begin::Input group--> */}
                <div className='row mb-6'>
                  {/* <!--begin::Label--> */}
                  <label className='col-lg-4 col-form-label fw-bold fs-6 required'>Image</label>
                  {/* <!--end::Label--> */}
                  {/* <!--begin::Col--> */}
                  <div className='col-lg-8'>
                    {/* <!--begin::Image input--> */}
                    <div className='image-input image-input-outline ' data-kt-image-input='true'>
                      {/* <!--begin::Preview existing avatar--> */}

                      <img
                        alt='images'
                        id='previewImage'
                        className='image-input-wrapper w-125px h-125px changeimg pointer'
                        src={
                          image
                            ? URL.createObjectURL(image)
                            : imageUrl === '' || imageUrl === null
                            ? toAbsoluteUrl('/media/default.jpg')
                            : imageUrl
                        }
                      />

                      {/* <!--end::Preview existing avatar--> */}
                      {/* <!--begin::Label--> */}
                      <label
                        className='btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow'
                        data-kt-image-input-action='change'
                        data-bs-toggle='tooltip'
                        title=''
                        data-bs-original-title='Change avatar'
                      >
                        <i className='fa fa-edit'></i>
                        {/* <!--begin::Inputs--> */}
                        <input
                          type='file'
                          name='image'
                          id='profileImage'
                          accept='.png, .jpg, .jpeg'
                          style={{display: 'none'}}
                          onChange={(e: any) => {
                            if (
                              e.target.files[0]['type'] != 'image/jpeg' &&
                              e.target.files[0]['type'] != 'image/jpg' &&
                              e.target.files[0]['type'] != 'image/png'
                            ) {
                              alert('Upload Only JPG, PNG Or PNG File')
                            } else if (
                              e.target.files[0] != null &&
                              e.target.files[0] != undefined
                            ) {
                              setImage(e.target.files[0])
                            }
                          }}
                        />
                        <input type='hidden' name='avatar_remove' />
                        {/* <!--end::Inputs--> */}
                      </label>
                      {/* <!--end::Label--> */}
                    </div>
                    {/* <!--end::Image input--> */}
                    {/* <!--begin::Hint--> */}
                    <div className='form-text' id='validimage'>
                      {t('Allowed file types: png, jpg, jpeg.')}
                    </div>
                    <label className='text-danger'>{error.imageError || ''}</label>
                    {/* <!--end::Hint--> */}
                  </div>
                  {/* <!--end::Col--> */}
                </div>
                {/* <!--end::Input group--> */}
              </div>

              <div>
                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                  {t('English Name')}
                </label>
                <input
                  type='text'
                  disabled={true}
                  name='categoryname'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t('English Name')}
                  value={enName}
                ></input>
                <label className='text-danger'>{error.enNameError || ''}</label>
              </div>
              <div>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>{t('Russian Name')}</label>
                <input
                  type='text'
                  disabled={true}
                  name='categoryname'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t('Russian Name')}
                  value={ruName}
                ></input>
                <label className='text-danger'>{error.ruNameError || ''}</label>
              </div>
              <div>
                <label className='col-lg-4 col-form-label fw-bold fs-6'>{t('Uzbek Name')}</label>
                <input
                  type='text'
                  disabled={true}
                  name='categoryname'
                  className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                  placeholder={t('Uzbek Name')}
                  value={uzName}
                ></input>
                <label className='text-danger'>{error.uzNameError || ''}</label>
              </div>

              {/* action button start */}
              <div className={`d-flex pt-15 justify-content-center`}>
                <button
                  type='button'
                  className={`btn btn-lg btn-light-success me-3`}
                  onClick={props.onHide}
                >
                  {t('Cancel')}
                </button>

                <button
                  type='button'
                  disabled={disable}
                  className={`btn btn-lg btn-success monthBtn me-3`}
                  onClick={() => validate()}
                >
                  {!disable && t('Save')}
                  {disable && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
              {/* action button end */}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }

function CategoryPage() {
  let t = Tr()
  const {menuIdEdit } = useMenuIdPermissions()

  const [showPopup, setShowPopup] = useState(false)
  const [categoryList, setCategoryList] = useState([])
  const [orgcategoryList, setOrgCategoryList] = useState([])
  const [categoryId, setcategoryId] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [focus, setFocus] = useState(0)

  var tmp: any = sessionStorage.getItem('customer')
  tmp = JSON.parse(tmp)



  // Define your DataTable columns
  const column = useMemo(
    () => [
      {
        name: t('Image'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5 d-flex align-items-center justify-content-center'>
              <img className='w-50px h-50px' src={row.image} alt='images' />
            </div>
          </div>
        ),
        sortable: false,
        filter: true,
      },
      {
        name: t('English Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.en_name != '' ? row.en_name : '-'}</div>
          </div>
        ),
        sortable: true,
        filter: true,
        selector: (row: any) => String(row.en_name),
      },
      {
        name: t('Russian Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.ru_name != '' ? row.ru_name : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.ru_name),
        filter: true,
      },
      {
        name: t('Uzbek Name'),
        cell: (row: any) => (
          <div className='my-3'>
            <div className='fw-bold fs-5'>{row.uz_name != '' ? row.uz_name : '-'}</div>
          </div>
        ),
        sortable: true,
        selector: (row: any) => String(row.uz_name),
        filter: true,
      },
      {
        name: t('Action'),
        cell: (row: any) => (
          <>
            {menuIdEdit ? (
              <button
                className='btn me-2 btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light'
                title='Edit'
                onClick={() => {
                  setShowPopup(true)
                  setcategoryId(row.categoryId)
                }}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>
            ) : (
              ''
            )}
          </>
        ),
        //   width:"140px"
      },
    ],
    [t]
  )

  // call category list api
  const categorylistapicall = async () => {
    var param: any = {}
    var response: any = await fetchData('admin/categorylist', param)

    if (response.status == '200') {
      setCategoryList(response.data)
      setOrgCategoryList(response.data)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Services'
    categorylistapicall()
  }, [])

  const CustomHeader = (props: any) => {
    const inputRef: any = useRef(null)

    // Define the onchange event handler
    const handleChange = async (e: any) => {
      // Focus on the input element when the onchange event is triggered
      await props.customSearch(e, 1)
    }
    useEffect(() => {
      // Check if the ref exists and if the component should be focused
      if (inputRef.current && props.isfoc === 1) {
        inputRef.current.focus()
      }
    }, [props.isfoc])
    return (
      <div className='row d-flex justify-content-between w-100 my-5'>
        <div className='d-flex align-items-center position-relative my-1 col-lg-4'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder={t('Search Services')}
            value={props.search}
            onChange={(e: any) => handleChange(e.target.value)}
            ref={inputRef}
          />
        </div>
        <div
          className='d-flex justify-content-end col-xl-8 '
          data-kt-user-table-toolbar='base'
        ></div>
      </div>
    )
  }

  //search function
  const categorysearch = async (text: any, isfoc: any) => {
    setSearchTerm(text)
    setFocus(isfoc)

    if (text == '' || text == null || text == undefined) {
      setCategoryList(orgcategoryList)
    } else {
      var tmp: any = orgcategoryList.filter(
        (item: any) =>
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase() == text.toLowerCase()) ||
          (item.en_name != null &&
            item.en_name != '' &&
            item.en_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.ru_name != null &&
            item.ru_name != '' &&
            item.ru_name.toLowerCase() == text.toLowerCase()) ||
          (item.ru_name != null &&
            item.ru_name != '' &&
            item.ru_name.toLowerCase().includes(text.toLowerCase())) ||
          (item.uz_name != null &&
            item.uz_name != '' &&
            item.uz_name.toLowerCase() == text.toLowerCase()) ||
          (item.uz_name != null &&
            item.uz_name != '' &&
            item.uz_name.toLowerCase().includes(text.toLowerCase()))
      )
      setCategoryList(tmp)
    }
  }

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='row mt-5'>
          <div className='col-12'>
            {orgcategoryList.length > 0 ? (
              <>
                <DataTable
                  columns={column}
                  data={categoryList}
                  pagination
                  paginationServer={false}
                  subHeader={true}
                  subHeaderComponent={
                    <CustomHeader search={searchTerm} isfoc={focus} customSearch={categorysearch} />
                  }
                  paginationComponentOptions={{
                    rowsPerPageText: t('Rows Per Page'),
                  }}
                />
              </>
            ) : (
              <>
                <div className='text-center px-4'>
                  <div className='d-flex justify-content-center align-items-center flex-column mt-10 pt-20 pb-2 mb-2'>
                    <h2 className='fs-2x fw-bold '>{t('Welcome To Category')}</h2>
                  </div>
                  <p className='text-gray-400 fs-4 fw-semibold '>
                    {t('There are no Category')}
                  </p>
                  {/* <Link
                    to='#'
                    className='btn btn-success monthBtn'
                    onClick={() => setShowPopup(true)}
                  >
                    {t('Add Category')}
                  </Link> */}
                  <br />
                </div>
                <div className='d-flex justify-content-center'>
                  <img
                    className='mw-100 mh-300px'
                    alt=''
                    src={toAbsoluteUrl('/media/illustrations/sketchy-1/2.png')}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {showPopup && (
          <Popup
            show={showPopup}
            onHide={() => {
              setShowPopup(false)
              setcategoryId(0)
                      categorylistapicall()

            }}
            categoryId={categoryId}
          />
        )}
      </div>
    </>
  )
}

export default CategoryPage
